'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Apply given filter string ( can be a filter name or a filter name plus parameters )
 * Useful for dynamic /parametrized filter usage.
 *
 * I.E {{ myNumber | useFilter:'currency:2' }}
 */
ngModule.filter('useFilter', function ($filter) {
  return function useFilter() {
    var filterString = arguments[1],
      value = arguments[0];
    if (filterString == null) {
      return "";
    }
    var splits = filterString.split(":"),
      filterName = _.first(splits),
      filterParams = _.drop(splits);
    filterParams.splice(0, 0, value);
    return $filter(filterName).apply(null, filterParams);
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/useFilter.js
// module id = 2708
// module chunks = 13